import PercentMaxPointsRewardCalculationTypeEditor from "../../../pages/actionModules/ActionModuleEditor/RewardCalculationEditor/PercentMaxPointsRewardCalculationTypeEditor";
import { RewardCalculationTypeDefinition } from "../actionModule";
import { RewardCalculationType } from "./rewardCalculationType";

export const PercentMaxPointsRewardCalculationType: RewardCalculationTypeDefinition = {
    name: "actionModules.rewardCalculationType.percentMaxPoints.name",
    defaultValue: {},
    type: RewardCalculationType.PercentMaxPointsCalculationType,
    editor: () => <PercentMaxPointsRewardCalculationTypeEditor />
};